import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { SurveyConfigEntries } from 'src/redux/slices/project/consts'
import { getProject } from 'src/redux/slices/project/endpoints'
import { selectSurveyProgress } from 'src/redux/slices/project/selectors'
import { SurveyProgress } from 'src/redux/slices/project/types'

import { Box, LinearProgress, Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import SurveyAccordion from './SurveyAccordion'
import SurveyTextField from './SurveyTextField'

const useStyles = makeStyles((theme: Theme) => createStyles({}))

const initialExpansionState: { [key in keyof SurveyProgress]: boolean } = {
  location: false,
  targets: false,
  utilityTargets: false,
  renewableSources: false,
  stockMakeup: false,
  fuelSettings: false,
  fuelBalance: false,
}

type SurveyProps = {
  isDrawer?: boolean
}
///// Component
const Survey: React.FC<SurveyProps> = ({ isDrawer }) => {
  const classes = useStyles()
  const { data: project, isLoading } = getProject.useQuery('')

  const [expanded, setExpanded] = useState(initialExpansionState)
  const handleToggleExpand = useCallback(
    (section: keyof SurveyProgress) => {
      return () =>
        setExpanded((prev) => {
          return {
            ...prev,
            [section]: !prev[section],
          }
        })
    },
    [setExpanded],
  )

  if (!project) return <LinearProgress />

  return (
    <Grid container justifyContent='center'>
      <Grid item xs={12} md={isDrawer ? 10 : 6}>
        {SurveyConfigEntries.map(([group, config]) => (
          <SurveyAccordion
            toggleConstructor={handleToggleExpand}
            key={`survey-field-accordion-${group}`}
            group={group}
            config={config}
            expanded={expanded}
            isDrawer={isDrawer}
          />
        ))}
      </Grid>
    </Grid>
  )
}
export default Survey
